export default __webpack_public_path__ + "images/pages/quiz/categories/mobile_makeup-0923b3e0590f01e47158312655336646.svg";